import React, {useEffect, useState} from 'react'
import {Button, Card, Row, Table} from "antd";
import {getAllShippingOrders, shippingOrderFilter, getShippingOrderWithPage} from "../../services/serviceShippingOrder";
import ShippingOrderCreate from "./ShippingOrderCreate";
import ShippingOrderActions from "./ShippingOrderActions";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import {SearchOutlined} from "@ant-design/icons";
import Filter from "../filterWrapper/Filter";
import ShippingOrderFilter from "./filter/ShippingOrderFilter";
import {useParams} from "@reach/router";
import { useLocation } from "@reach/router";

const completedStyle = {
    fontWeight: 'bold',
    color: 'rgba(234,6,61,0.7)'
}


const ShippingOrder = ({navigate}) => {
    const location = useLocation();
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [openFilter, setOpenFilter] = useState(false);
    const [filters, setFilters] = useState({
        customerName: '',
        dispatchNo: '',
        date: null,
    });
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getShippingOrders(page, pageSize);
    }, [location.search]);

    const handleFilterReset = () => {
        const baseObj = {
            customerName: '',
            dispatchNo: '',
            date: null,
        };

        getShippingOrders(1, 10, baseObj);
    }

    const getShippingOrders = (page, pageSize, requestObj = filters) => {
        const mockFilters = {...requestObj};
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        getShippingOrderWithPage(mockFilters)
            .then(({data}) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    const handlers = {
        updater() {
            getShippingOrders(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            const sorted = list.map((item, idx) => ({
                    key: item.id,
                    id: item.id,
                    completed: item.c,
                    customerCode: item.cn || '',
                    customerShippingCode: item.coN || '',
                    customerAddress: item.caT || '',
                    dispatchNo: item.dn || '',
                    shipmentType: item.st ||'',
                    createdDate: item.cd || '',
                    payment: item.bp || ''
            }))
            setSortedList(sorted)
        }
    }
    function handleFilter ({customerName, dispatchNo, date}) {
        arguments[0].date = arguments[0].date.hasOwnProperty('_d') ? arguments[0].date._d : null
        const requestObj = {}
        Object.keys(arguments[0]).map(key => {
            requestObj[key] = arguments[0][key]
        })
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
        return new Promise((resolve) => resolve(200))
    }
    const columns = [
        {
            title: 'Oluşturulma Tarihi',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (t) => userDateFormatter(t)
        },
        {
            title: 'Müşteri',
            dataIndex: 'customerCode',
            key: 'customerCode',
            render: (t, r) => r.completed ? <span style={completedStyle}>{t.slice(0,30)}</span> : <span>{t.slice(0, 30)}</span>
        },
        {
            title: 'Müşteri Sipariş No',
            dataIndex: 'customerShippingCode',
            key: 'customerShippingCode'
        },
        {
            title: 'İrsaliye No',
            dataIndex: 'dispatchNo',
            key: 'dispatchNo'
        },
        {
            title: 'Ödeme Vadesi',
            dataIndex: 'payment',
            key: 'payment'
        },
        {
            title: 'Adres Başlığı',
            dataIndex: 'customerAddress',
            key: 'customerAddress'
        },
        {
            title: 'Gönderi Şekli',
            dataIndex: 'shipmentType',
            render: (t) => t === 'VEHICLE' ? 'ARAÇ' : t === 'MANUEL' ? 'ELDEN' : 'KARGO'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <ShippingOrderActions record={record} updater={handlers.updater}/>
        }
    ]

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    return (
        <React.Fragment>

            <Card title={'Sevkiyat Emri Listesi'}
                  extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                </Row>
                <Table scroll={{x: 'max-content'}} columns={columns} dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        onChange: handlePaginationChange,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        showSizeChanger: true
                    }}
                />
            </Card>

            {
                newModal
                    ? <ShippingOrderCreate
                        show={newModal}
                        modalCloser={handlers.modalCloser}
                        updater={handlers.updater}/>
                    : null
            }
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Sevkiyat Emri'}
                    handler={handleFilter}
                    resetHandler={handleFilterReset}
                >
                    <ShippingOrderFilter/>
                </Filter>
            }

        </React.Fragment>
    )
}
export default ShippingOrder